import { Component, Input, Renderer2, EventEmitter, Output} from '@angular/core';
import { NgbDatepickerI18n, NgbDateStruct, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { I18n, CustomDatepickerI18n } from './datepicker.service';
import { PropertyGroup, QueovalItem, HtmlBase, BObjectModel, PropertyData, FormatDate } from '../../../../models';
import { ToastService } from '../../../../toast';
import { parseTime } from '../../../../utilities';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'q-datepicker',
  templateUrl: './datepicker.component.html',
  styleUrls: ['./datepicker.component.css', '../../dynamictag.component.css'],
  providers: [I18n, { provide: NgbDatepickerI18n, useClass: CustomDatepickerI18n }] // define custom NgbDatepickerI18n provide

})

export class DatepickerComponent {

  // #region VARIABLES GLOBALES

  // #region public
  //public type: string;
  public input: PropertyData;
  public loaded: boolean;
  public arrayInput: PropertyData[];
  public init: boolean;
  public currentDate: number;
  public cycleElEntryPoint: string = '';
  public Date: Date | null;
  // #endregion

  // #region private
  private dateDebut: Date;
  private dateFin: Date;
  // #endregion

  // #endregion

  // #region DIRECTIVES
  // tslint:disable-next-line:no-input-rename
  @Input('model') model: BObjectModel;
  @Input('input')
  set inputs(value: any) {
    this.arrayInput = [];
    this.input = value;
    this.loaded = false;
    //this.type = value.Mode;
    setTimeout(() => {
      if (this.input.MainElementList) {

        if (this.input.MainElementList[0].Mask === 'DATEDEBUT') {
          this.model.Body.SelectedGroupsList.forEach((element: PropertyGroup) => {
            for (let i: number = 0; i < element.DataList.length; i++) {
              if (element.DataList[i].MainElementList[0].Mask === 'DATEDEBUT') {
                this.arrayInput.push(element.DataList[i]);
                this.arrayInput.push(element.DataList[i + 1]);
                this.dateDebut = this.arrayInput[0].MainElementList[0].ValueGeneric;
                this.dateFin = this.arrayInput[1].MainElementList[0].ValueGeneric;
                if (value.QueovalCode !== 'DATE') {
                  this.getDate();
                }
                break;
              }
            }
          });

          setTimeout(() => {
            this.verifyDateAfterFirstLoad();
          }, 0);
          // setTimeout(() => {
          //   if (this.dateDebut && this.dateFin) {
          //     this.verifyDate('DATEFIN', 'min', 1, 2);
          //   }
          // }, 0);
        }

        const splitedDate: Array<any> = this.input.MainElementList[0].Value.split('/');
        if (splitedDate.length === 3 && splitedDate[2].toString() !== '0000') {
          this.Date = new Date(splitedDate[2], splitedDate[1] - 1, splitedDate[0]);
        } else {
          this.Date = null;
        }

      }
      this.loaded = true;
    }, 0);
  }
  //////@Input('view') view: string;

  @Output() sendDate: EventEmitter<Date> = new EventEmitter<Date>(true);
  @Output() navig: EventEmitter<HtmlBase> = new EventEmitter<HtmlBase>(false);
  //   // #endregion

  // #region CONSTRUCTEUR
  constructor(
    public render: Renderer2,
    private toastservice: ToastService,
    private modalService: NgbModal,
  ) { }
  //   // #endregion

  // #region FONCTIONS PUBLIQUES
  //  renvoie de la date pour un composant SIMPLE
  public onDateSelect(e: any, input: any): void {
    input.Value = `${this.formatDate(e.day, e.month).day}/${this.formatDate(e.day, e.month).month}/${e.year}`;
    this.sendDate.emit(this.normalizeDate(e));
  }




  private normalizeDate(date: any): Date {
    return new Date(Number(date.year), Number(date.month), Number(date.day));
  }

  //GGPP
  //public isDisabled = (date: NgbDateStruct, current: { month: number }): boolean => {
  //  return date.month !== current.month;
  //}




  // #region DatePick natif
  public onDateSelectNatif(value: string, input: HtmlBase): void {
    if (value !== '') {
      const splitedDate: Array<string> = value.split('-');
      this.Date = new Date(Number(splitedDate[0]), Number(splitedDate[1]) - 1, Number(splitedDate[2]));
      input.Value = `${splitedDate[2]}/${splitedDate[1]}/${splitedDate[0]}`;
    } else {
      this.Date = null;
      input.Value = `00/00/0000`;
    }
    this.sendDate.emit((this.Date as Date));
  }

  public onDateSelectComplexNatif(e: any, input: HtmlBase): void {
    if (e !== '') {
      const splitedDate: Array<number> = e.split('-');
      const newDate: Date = new Date(splitedDate[0], splitedDate[1] - 1, splitedDate[2]);

      if (input.Mask === 'DATEDEBUT') {
        if (this.testDate(newDate, this.dateFin)) {
          this.affectDateToDatePickerNatif(newDate);
        } else {
          this.affectDateToDatePickerNatif(newDate, input.Mask);
        }
      }
      if (input.Mask === 'DATEFIN') {
        if (this.testDate(this.dateDebut, newDate)) {
          this.affectDateToDatePickerNatif(newDate);
        } else {
          this.affectDateToDatePickerNatif(newDate, input.Mask);
        }
      }
    }
    this.compareDate(input.Mask);
  }

  public checkEmptyValue(e: any, input: HtmlBase): void {
    if (e.target.value === '') {
      if (input.Required) {
        this.toastservice.showAlertToast('Le format de la date n\'est pas correct');
        const value: any = input.ValueGeneric;
        input.ValueGeneric = null;
        setTimeout(() => {
          input.ValueGeneric = value;
        }, 0);

      } else {
        input.ValueGeneric = null;
        input.Value = `00/00/0000`;
        if (input.Mask === 'DATEDEBUT') {
          this.dateDebut = new Date(0, 0, 0);
        }
        if (input.Mask === 'DATEFIN') {
          this.dateFin = new Date(0, 0, 0);
        }
      }
    }
  }

  private affectDateToDatePickerNatif(date: Date, mask?: string): void {
    const strDate: string = `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`;
    if (!mask) {
      this.dateDebut.valueOf = date.valueOf;
      this.dateFin.valueOf = date.valueOf;

      this.arrayInput[0].MainElementList[0].Value = strDate;
      this.arrayInput[0].MainElementList[0].ValueGeneric = date;

      this.arrayInput[1].MainElementList[0].Value = strDate;
      this.arrayInput[1].MainElementList[0].ValueGeneric = date;
    } else {
      if (mask === 'DATEDEBUT') {
        this.dateDebut = date;
        this.arrayInput[0].MainElementList[0].Value = strDate;
      }
      if (mask === 'DATEFIN') {
        this.dateFin = date;
        this.arrayInput[1].MainElementList[0].Value = strDate;
      }
    }
  }

  private testDate(date1: Date, date2: Date): boolean {
    const nDate1: Date = new Date(date1.getFullYear(), date1.getMonth(), date1.getDate());
    const nDate2: Date = new Date(date2.getFullYear(), date2.getMonth(), date2.getDate());
    return nDate1 >= nDate2;
  }
  // #endregion


  // renvoie de la date pour un composant COMPLEXE
  public onDateSelectComplex(e: any, input: HtmlBase): void {
    if (input.Mask === 'DATEDEBUT') {
      const dateDebut: Date = new Date(e.year, e.month - 1, e.day);
      const dateFin: Date = new Date(this.dateFin.getFullYear(), this.dateFin.getMonth(), this.dateFin.getDate());
      if (dateDebut >= dateFin) {
        this.affectDateToDatePicker(e);
      } else {
        this.affectDateToDatePicker(e, input.Mask);
      }
    }
    if (input.Mask === 'DATEFIN') {
      const dateFin: Date = new Date(e.year, e.month - 1, e.day);
      const dateDebut: Date = new Date(this.dateDebut.getFullYear(), this.dateDebut.getMonth(), this.dateDebut.getDate());
      if (dateDebut >= dateFin) {
        this.affectDateToDatePicker(e);
      } else {
        this.affectDateToDatePicker(e, input.Mask);
      }
    }
    this.compareDate(input.Mask);
  }

  public selectChangeComplex(selectedValue: string, selectItem: HtmlBase, type: string): void {
    let indexArray: number = 0;
    let indexElementList: number = 0;
    switch (selectItem.Mask) {
      case 'DATEDEBUT':
        indexArray = 0;
        break;
      case 'DATEFIN':
        indexArray = 1;
        break;
    }

    switch (type) {
      case 'hour':
        indexElementList = 1;
        break;
      case 'min':
        indexElementList = 2;
        break;
    }

    let hour: number = 0;
    let minute: number = 0;
    this.arrayInput[indexArray].MainElementList[indexElementList].SelectOptionsList.forEach((element: QueovalItem) => {
      if (element.Value === selectedValue) {
        element.Selected = true;
        if (indexElementList === 1) {
          hour = Number(element.Value);
          minute = Number(this.arrayInput[indexArray].MainElementList[indexElementList + 1].SelectOptionsList.filter((el: QueovalItem) => el.Selected)[0].Value);
        }
        if (indexElementList === 2) {
          minute = Number(element.Value);
          hour = Number(this.arrayInput[indexArray].MainElementList[indexElementList - 1].SelectOptionsList.filter((el: QueovalItem) => el.Selected)[0].Value);
        }
      } else {
        element.Selected = false;
      }
    });
    if (indexArray === 0) {
      this.dateDebut.setMinutes(minute);
      this.dateDebut.setHours(hour);
    }
    if (indexArray === 1) {
      this.dateFin.setMinutes(minute);
      this.dateFin.setHours(hour);
    }
    this.compareDate(selectItem.Mask);
  }

  public selectChange(selectedValue: string, selectItem: HtmlBase): void {
    selectItem.SelectOptionsList.forEach((element: QueovalItem) => {
      if (element.Value === selectedValue) {
        element.Selected = true;
      } else {
        element.Selected = false;
      }
    });
  }

  public affectDate(e: string): void {
    this.currentDate = Number(e.split('/')[0]);
  }

  public KeyUpOnDate(e: any, selectItem: HtmlBase): void {
    if (e.code === 'Enter') {
      const value: any = e.target.value;
      this.blurOnDatePiker(value, selectItem);
    }
  }

  public blurOnDatePiker(value: string, selectItem: HtmlBase): void {

    let day: number = 0;
    let month: number = 0;
    let year: number = 0;
    const date: Array<string> = value.split('/');
    if (date.length === 3) {
      if (date[0].length === 2 && Number(date[0]) > 0 && Number(date[0]) <= 31) {
        day = Number(date[0]);
      } else {
        if (selectItem.Mask === 'DATEDEBUT') {
          day = this.dateFin.getDate();
        }
        if (selectItem.Mask === 'DATEFIN') {
          day = this.dateDebut.getDate();
        }
      }
      if (date[1].length === 2 && Number(date[1]) > 0 && Number(date[1]) <= 12) {
        month = Number(date[1]);
      } else {
        if (selectItem.Mask === 'DATEDEBUT') {
          month = this.dateFin.getMonth();
        }
        if (selectItem.Mask === 'DATEFIN') {
          month = this.dateDebut.getMonth();
        }
      }
      if (date[2].length === 4) {
        year = Number(date[2]);
      } else {
        if (selectItem.Mask === 'DATEDEBUT') {
          year = this.dateFin.getFullYear();
        }
        if (selectItem.Mask === 'DATEFIN') {
          year = this.dateDebut.getFullYear();
        }
      }
      const e: { year: number, month: number, day: number } = { year, month, day };
      if (selectItem.Mask === 'DATEDEBUT') {
        const dateDebut: Date = new Date(year, month - 1, day);
        const dateFin: Date = new Date(this.dateFin.getFullYear(), this.dateFin.getMonth(), this.dateFin.getDate());
        if (dateDebut >= dateFin) {
          this.affectDateToDatePicker(e);
        } else {
          this.affectDateToDatePicker(e, selectItem.Mask);
        }
      }
      if (selectItem.Mask === 'DATEFIN') {
        const dateFin: Date = new Date(year, month - 1, day);
        const dateDebut: Date = new Date(this.dateDebut.getFullYear(), this.dateDebut.getMonth(), this.dateDebut.getDate());
        if (dateDebut >= dateFin) {
          this.affectDateToDatePicker(e);
        } else {
          this.affectDateToDatePicker(e, selectItem.Mask);
        }
      }
    } else if (value.length === 6 || value.length === 8) {
      if (Number(value.substring(0, 2)) > 0 && Number(value.substring(0, 2)) <= 31) {
        day = Number(value.substring(0, 2));
        if (Number(value.substring(2, 4)) > 0 && Number(value.substring(2, 4)) <= 12) {
          month = Number(value.substring(2, 4));
          if (Number(value.substring(4, 6)) > 0 && Number(value.substring(4, 6)) <= 99 || Number(value.substring(4, 8)) >= 1900 && Number(value.substring(4, 8)) <= 2999) {
            if (Number(value.substring(4, 6)) >= 0 && Number(value.substring(4, 6)) <= 99) {
              year = Number(`20${value.substring(4, 6)}`);
            }
            if (Number(value.substring(4, 8)) >= 1900 && Number(value.substring(4, 8)) <= 2999) {
              year = Number(value.substring(4, 8));
            }
            const e: { year: number, month: number, day: number } = { year, month, day };
            if (selectItem.Mask === 'DATEDEBUT') {
              const dateDebut: Date = new Date(year, month - 1, day);
              const dateFin: Date = new Date(this.dateFin.getFullYear(), this.dateFin.getMonth(), this.dateFin.getDate());
              if (dateDebut >= dateFin) {
                this.affectDateToDatePicker(e);
              } else {
                this.affectDateToDatePicker(e, selectItem.Mask);
              }
            }
            if (selectItem.Mask === 'DATEFIN') {
              const dateFin: Date = new Date(year, month - 1, day);
              const dateDebut: Date = new Date(this.dateDebut.getFullYear(), this.dateDebut.getMonth(), this.dateDebut.getDate());
              if (dateDebut >= dateFin) {
                this.affectDateToDatePicker(e);
              } else {
                this.affectDateToDatePicker(e, selectItem.Mask);
              }
            }
            this.compareDate(selectItem.Mask);
          } else {
            this.isErrorFormat(selectItem);
          }
        } else {
          this.isErrorFormat(selectItem);
        }
      } else {
        this.isErrorFormat(selectItem);
      }
    } else {
      this.isErrorFormat(selectItem);
    }
  }

  public onClickButton(button: HtmlBase, pContent: any): void {
    switch (button.TypeModal.toUpperCase()) {
      case 'MODAL':
        if (this.input) {
          this.cycleElEntryPoint = button.MoreValues['Table'];
          this.OpenModal(pContent)
        }
        break;
      default:
        this.navig.emit(button);
    }
  }

  public OpenModal(content: any) {
    this.modalService.open(content, { size: 'xl', centered: true, windowClass: 'modal-datepicker' }).result.then((result) => {
      switch (result) {
        //  case 'SAVE': this.saveConfigSignature(); break;
        //  case 'CANCEL': this.closeConfigSignature(); break;
      }
    });
  }
  // #endregion

  // #region FONCTIONS PRIVEES
  private formatDate(day: number, month: number): FormatDate {
    return {
      day: parseTime(day),
      month: parseTime(month)
    };
  }

  private isErrorFormat(html: HtmlBase): void {
    if (html.Mask === 'DATEDEBUT') {
      this.dateDebut.setFullYear(this.dateFin.getFullYear());
      this.dateDebut.setMonth(this.dateFin.getMonth());
      this.dateDebut.setDate(this.dateFin.getDate());
      this.arrayInput[0].MainElementList[0].Value = `${parseTime(this.dateFin.getDate())}/${parseTime(this.dateFin.getMonth() + 1)}/${this.dateFin.getFullYear()}`;
    }
    if (html.Mask === 'DATEFIN') {
      this.dateFin.setFullYear(this.dateDebut.getFullYear());
      this.dateFin.setMonth(this.dateDebut.getMonth());
      this.dateFin.setDate(this.dateDebut.getDate());
      this.arrayInput[1].MainElementList[0].Value = `${parseTime(this.dateDebut.getDate())}/${parseTime(this.dateDebut.getMonth() + 1)}/${this.dateDebut.getFullYear()}`;
    }
    this.toastservice.showAlertToast('Le format de la date n\'est pas correct');
  }

  private verifyDateAfterFirstLoad(): void {
    if (this.dateDebut >= this.dateFin) {
      const minute: number = this.dateDebut.getMinutes();
      const hour: number = this.dateFin.getHours() + 1;

      this.arrayInput[1].MainElementList[1].SelectOptionsList.forEach((element: QueovalItem) => {
        if (Number(element.Value) === hour) {
          element.Selected = true;
        } else {
          element.Selected = false;
        }
      });
      this.arrayInput[1].MainElementList[2].SelectOptionsList.forEach((element: QueovalItem) => {
        if (Number(element.Value) === minute) {
          element.Selected = true;
        } else {
          element.Selected = false;
        }
      });
      this.dateFin.setMinutes(minute);
      this.dateFin.setHours(hour);
    }
  }

  private affectDateToDatePicker(e: any, mask?: string): void {
    const day: string = parseTime(e.day);
    const month: string = parseTime(e.month);
    if (!mask) {
      this.dateDebut.setFullYear(e.year);
      this.dateDebut.setMonth(e.month - 1);
      this.dateDebut.setDate(e.day);
      this.dateFin.setFullYear(e.year);
      this.dateFin.setMonth(e.month - 1);
      this.dateFin.setDate(e.day);
      this.arrayInput[0].MainElementList[0].Value = `${day}/${month}/${e.year}`;
      this.arrayInput[1].MainElementList[0].Value = `${day}/${month}/${e.year}`;
    } else {
      if (mask === 'DATEDEBUT') {
        this.dateDebut.setFullYear(e.year);
        this.dateDebut.setMonth(e.month - 1);
        this.dateDebut.setDate(e.day);
        this.arrayInput[0].MainElementList[0].Value = `${day}/${month}/${e.year}`;
      }
      if (mask === 'DATEFIN') {
        this.dateFin.setFullYear(e.year);
        this.dateFin.setMonth(e.month - 1);
        this.dateFin.setDate(e.day);
        this.arrayInput[1].MainElementList[0].Value = `${day}/${month}/${e.year}`;
      }
    }
  }

  private compareDate(dateSelected: string): void {
    let minute: number = 0;
    let hour: number = 0;
    if (this.dateDebut >= this.dateFin) {
    if (dateSelected === 'DATEDEBUT') {
      minute = this.dateDebut.getMinutes();
      hour = this.dateDebut.getHours();

      if (minute < 30) {
        minute += 30;
      } else {
        minute -= 30;
        hour += 1;
      }

      this.arrayInput[1].MainElementList[1].SelectOptionsList.forEach((element: QueovalItem) => {
        if (Number(element.Value) === hour) {
          element.Selected = true;
        } else {
          element.Selected = false;
        }
      });
      this.arrayInput[1].MainElementList[2].SelectOptionsList.forEach((element: QueovalItem) => {
        if (Number(element.Value) === minute) {
          element.Selected = true;
        } else {
          element.Selected = false;
        }
      });
      this.dateFin.setMinutes(minute);
      this.dateFin.setHours(hour);
    }
    if (dateSelected === 'DATEFIN') {
      minute = this.dateFin.getMinutes();
      hour = this.dateFin.getHours();


      if (minute < 30) {
        minute += 30;
        hour -= 1;
      } else {
        minute -= 30;
      }

      this.arrayInput[0].MainElementList[1].SelectOptionsList.forEach((element: QueovalItem) => {
        if (Number(element.Value) === hour) {
          element.Selected = true;
        } else {
          element.Selected = false;
        }
      });
      this.arrayInput[0].MainElementList[2].SelectOptionsList.forEach((element: QueovalItem) => {
        if (Number(element.Value) === minute) {
          element.Selected = true;
        } else {
          element.Selected = false;
        }
      });
      this.dateDebut.setMinutes(minute);
      this.dateDebut.setHours(hour);
      }
    }
    // this.arrayInput = JSON.parse(JSON.stringify(this.arrayInput));
  }

  private getDate(): void {

    const getdateofday: any = (item: PropertyData): any => {
      // déclaration de la date du jour
      const dateOfDay: Date = new Date();
      const dayOfDay: number = dateOfDay.getDate();
      const monthOfDay: number = dateOfDay.getMonth();
      const yearOfDay: number = dateOfDay.getFullYear();

      // récupération de la valeur dans le datepicker
      const date: Array<string> = item.MainElementList[0].Value.split('/');
      // renvoie la date du jour si la date récupérée est 00/00/0000
      const year: number = date[2] === '0000' ? yearOfDay : Number(date[2]);
      const month: number = date[1] === '00' ? monthOfDay : Number(date[1]);
      const day: number = date[0] === '00' ? dayOfDay : Number(date[0]);
      const hour: number = Number(item.MainElementList[1].Value);
      const minute: number = Number(item.MainElementList[2].Value);

      // les mois sont décalés de 1 à cause du rang du premier argument d'une liste qui est 0
      return new Date(year, month - 1, day, hour, minute, 0, 0);
    };

    // affectation de getdateogday au datepicker selectionné
    this.dateDebut = getdateofday(this.arrayInput[0]);
    this.dateFin = getdateofday(this.arrayInput[1]);

    // affection de la date de début au datepicker
    const formatedDateDebut: FormatDate = this.formatDate(this.dateDebut.getDate(), this.dateDebut.getMonth() + 1);
    this.arrayInput[0].MainElementList[0].Value = `${formatedDateDebut.day}/${formatedDateDebut.month}/${this.dateDebut.getFullYear()}`;
    this.arrayInput[0].MainElementList[0].ValueGeneric = new Date(this.dateDebut.getFullYear(), this.dateDebut.getMonth(), this.dateDebut.getDate());
    // affection de la date de fin au datepicker
    const formatedDateFin: FormatDate = this.formatDate(this.dateFin.getDate(), this.dateFin.getMonth() + 1);
    this.arrayInput[1].MainElementList[0].Value = `${formatedDateFin.day}/${formatedDateFin.month}/${this.dateFin.getFullYear()}`;
    this.arrayInput[1].MainElementList[0].ValueGeneric = new Date(this.dateFin.getFullYear(), this.dateFin.getMonth(), this.dateFin.getDate());

  }

  // #endregion
}

